import { takeLatest, put, all, call } from "redux-saga/effects";
import { encryptData } from "../../../_common/enode-decode";
import SaleDetailsActionTypes from "./saleDetails.types";
import {
  createSaleFailure,
  createSaleSuccess,
  createSaleChanged,
  fetchSaleDetailsFailure,
  fetchSaleDetailsSuccess,
  fetchSaleDetailsChanged,
  updateSaleFailure,
  updateSaleSuccess,
  updateSaleChanged,
} from "./saleDetails.action";
import {
  createSaleApi,
  fetchSaleDetailsApi,
  updateSaleApi,
} from "./saleDetails.services";

const isSaleApiFailure = (data: any) =>
  String(data?.statusCode ?? data?.StatusCode ?? "") === "100";

/** *********************  START FETCH SALE DETAILS  ******************** */
export function* fetchSaleDetailsSaga({ payload }: any) {
  try {
    const key = "FetchSaleKey";
    const { SaleID, CompanyID, InstanceName, LeadID } = payload;
    const jsonData = {
      SaleID: SaleID,
      CompanyID: CompanyID,
      InstanceName: InstanceName,
      LeadID: LeadID,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchSaleDetailsApi, encodeData);
    if (isSaleApiFailure(responseData.data)) {
      yield put(fetchSaleDetailsFailure(responseData.data));
    } else {
      yield put(fetchSaleDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchSaleDetailsFailure(error));
  }
}

export function* resetFetchSaleDetailsResponse() {
  yield put(fetchSaleDetailsChanged());
}

export function* onFetchSaleDetails() {
  yield takeLatest(
    SaleDetailsActionTypes.FETCH_SALE_DETAILS_START,
    fetchSaleDetailsSaga,
  );
}

export function* onFetchSaleDetailsResponseReset() {
  yield takeLatest(
    SaleDetailsActionTypes.FETCH_SALE_DETAILS_RESPONSE_RESET,
    resetFetchSaleDetailsResponse,
  );
}
/** *********************  END FETCH SALE DETAILS  ******************** */

/** *********************  START CREATE SALE  ******************** */
export function* createSaleSaga({ payload }: any) {
  try {
    const KEY = "CreateSaleKey";
    const numMachines =
      payload.NumberOfMachines ??
      payload.loanDetailsNoOfMachines ??
      payload.LoanDetailsNoOfMachines ??
      "";
    const numEpos =
      payload.NumberOfEPOS ??
      payload.loanDetailsNoOfEPOS ??
      payload.LoanDetailsNoOfEPOS ??
      "";

    const jsonData: any = {
      SaleID: payload.SaleID ?? payload.saleID,
      CompanyID: payload.CompanyID,
      CreatedBy: payload.CreatedBy,
      LeadID: payload.LeadID,
      InstanceName: payload.InstanceName,
      BusinessName: String(
        payload.BusinessName ?? payload.businessName ?? "",
      ).trim(),
      UnderContracts: payload.UnderContracts ?? payload.underContracts ?? "",
      CurrentProvider: payload.CurrentProvider ?? payload.currentProvider ?? "",
      ProviderIntroducedBySeddel:
        payload.ProviderIntroducedBySeddel ??
        payload.providerIntroducedBySeddel ??
        "",
      NumberOfMachines: String(numMachines),
      NumberOfEPOS: String(numEpos),
      CurrentProviderCommands: String(
        payload.CurrentProviderCommands ??
          payload.currentProviderCommands ??
          "",
      ),
      UnderContractsCommands: String(
        payload.UnderContractsCommands ?? payload.underContractsCommands ?? "",
      ),
      SaleDate: String(payload.SaleDate ?? payload.saleDate ?? "").trim(),
      UnderContactDate: String(
        payload.UnderContactDate ?? payload.underContactDate ?? "",
      ).trim(),
      UserName: String(payload.UserName ?? payload.userName ?? ""),
      PreviousStatus: String(
        payload.PreviousStatus ?? payload.previousStatus ?? "",
      ),
      CurrentStatus: String(
        payload.CurrentStatus ?? payload.currentStatus ?? "",
      ),
      PreviousStatusID: String(
        payload.PreviousStatusID ?? payload.previousStatusID ?? "",
      ),
      CurrentStatusID: String(
        payload.CurrentStatusID ?? payload.currentStatusID ?? "",
      ),
      LogMessage: String(payload.LogMessage ?? payload.logMessage ?? ""),
    };

    const statusId =
      payload.StatusID ??
      payload.statusID ??
      payload.CurrentStatusID ??
      payload.currentStatusID;
    if (statusId !== undefined && statusId !== null) {
      jsonData.StatusID = String(statusId);
    }
    const encodeData = encryptData(jsonData, KEY);
    // @ts-ignore
    const responseData = yield call(createSaleApi, encodeData);
    if (isSaleApiFailure(responseData.data)) {
      yield put(createSaleFailure(responseData.data));
    } else {
      yield put(createSaleSuccess(responseData.data));
    }
  } catch (error) {
    yield put(createSaleFailure(error));
  }
}

export function* resetCreateSaleResponse() {
  yield put(createSaleChanged());
}

export function* onCreateSale() {
  yield takeLatest(SaleDetailsActionTypes.CREATE_SALE_START, createSaleSaga);
}

export function* onCreateSaleResponseReset() {
  yield takeLatest(
    SaleDetailsActionTypes.CREATE_SALE_RESPONSE_RESET,
    resetCreateSaleResponse,
  );
}
/** *********************  END CREATE SALE  ******************** */

/** *********************  START UPDATE SALE  ******************** */
export function* updateSaleSaga({ payload }: any) {
  try {
    const KEY = "UpdateSaleKey";
    const numMachines =
      payload.NumberOfMachines ??
      payload.loanDetailsNoOfMachines ??
      payload.LoanDetailsNoOfMachines ??
      "";
    const numEpos =
      payload.NumberOfEPOS ??
      payload.loanDetailsNoOfEPOS ??
      payload.LoanDetailsNoOfEPOS ??
      "";

    const jsonData: any = {
      SaleID: payload.SaleID,
      CompanyID: payload.CompanyID,
      UpdatedBy: payload.UserID,
      LeadID: String(payload.LeadID ?? payload.leadID ?? "").trim(),
      InstanceName: payload.InstanceName,
      BusinessName: String(
        payload.BusinessName ?? payload.businessName ?? "",
      ).trim(),
      UnderContracts: payload.UnderContracts ?? payload.underContracts ?? "",
      CurrentProvider: payload.CurrentProvider ?? payload.currentProvider ?? "",
      ProviderIntroducedBySeddel:
        payload.ProviderIntroducedBySeddel ??
        payload.providerIntroducedBySeddel ??
        "",
      NumberOfMachines: String(numMachines),
      NumberOfEPOS: String(numEpos),
      CurrentProviderCommands: String(
        payload.CurrentProviderCommands ??
          payload.currentProviderCommands ??
          "",
      ),
      UnderContractsCommands: String(
        payload.UnderContractsCommands ?? payload.underContractsCommands ?? "",
      ),
      SaleDate: String(payload.SaleDate ?? payload.saleDate ?? "").trim(),
      UnderContactDate: String(
        payload.UnderContactDate ?? payload.underContactDate ?? "",
      ).trim(),
      UserName: String(payload.UserName ?? payload.userName ?? ""),
      PreviousStatus: String(
        payload.PreviousStatus ?? payload.previousStatus ?? "",
      ),
      CurrentStatus: String(
        payload.CurrentStatus ?? payload.currentStatus ?? "",
      ),
      PreviousStatusID: String(
        payload.PreviousStatusID ?? payload.previousStatusID ?? "",
      ),
      CurrentStatusID: String(
        payload.CurrentStatusID ?? payload.currentStatusID ?? "",
      ),
      LogMessage: String(payload.LogMessage ?? payload.logMessage ?? ""),
    };

    const statusId =
      payload.StatusID ??
      payload.statusID ??
      payload.CurrentStatusID ??
      payload.currentStatusID;
    if (statusId !== undefined && statusId !== null) {
      jsonData.StatusID = String(statusId);
    }
    const encodeData = encryptData(jsonData, KEY);
    // @ts-ignore
    const responseData = yield call(updateSaleApi, encodeData);
    if (isSaleApiFailure(responseData.data)) {
      yield put(updateSaleFailure(responseData.data));
    } else {
      yield put(updateSaleSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateSaleFailure(error));
  }
}

export function* resetUpdateSaleResponse() {
  yield put(updateSaleChanged());
}

export function* onUpdateSale() {
  yield takeLatest(SaleDetailsActionTypes.UPDATE_SALE_START, updateSaleSaga);
}

export function* onUpdateSaleResponseReset() {
  yield takeLatest(
    SaleDetailsActionTypes.UPDATE_SALE_RESPONSE_RESET,
    resetUpdateSaleResponse,
  );
}
/** *********************  END UPDATE SALE  ******************** */

export function* saleDetailsSaga() {
  yield all([
    call(onFetchSaleDetails),
    call(onFetchSaleDetailsResponseReset),
    call(onCreateSale),
    call(onCreateSaleResponseReset),
    call(onUpdateSale),
    call(onUpdateSaleResponseReset),
  ]);
}
